/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AppDataExRes } from '../../models/app-data-ex-res';

export interface ApiAppDataGet$Params {
  config?: string;

/**
 * User's Working Group
 */
  UserWorkingGroup?: String;
}

export function apiAppDataGet(http: HttpClient, rootUrl: string, params?: ApiAppDataGet$Params, context?: HttpContext): Observable<StrictHttpResponse<AppDataExRes>> {
  const rb = new RequestBuilder(rootUrl, apiAppDataGet.PATH, 'get');
  if (params) {
    rb.query('config', params.config, {});
    rb.header('UserWorkingGroup', params.UserWorkingGroup, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AppDataExRes>;
    })
  );
}

apiAppDataGet.PATH = '/api/app/data';
